import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 44 44"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("g", {
      fill: "none",
      "fill-rule": "evenodd"
    }, [
      _createElementVNode("circle", {
        cx: "22",
        cy: "22",
        r: "22",
        fill: "var(--status-svg-color)"
      }),
      _createElementVNode("path", {
        fill: "#FFF",
        "fill-rule": "nonzero",
        d: "M15 34h14c1.103 0 2-.897 2-2V15c0-1.103-.897-2-2-2h-4c0-1.655-1.346-3-3-3s-3 1.345-3 3h-4c-1.103 0-2 .897-2 2v17c0 1.103.897 2 2 2m6-21a1.001 1.001 0 0 1 2 0v1a1 1 0 0 0 1 1h1v2h-6v-2h1a1 1 0 0 0 1-1zm-6 2h2v2c0 1.103.897 2 2 2h6c1.103 0 2-.897 2-2v-2h2v17H15z"
      })
    ], -1)
  ]))]))
}
export default { render: render }